/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetInactivitiesQueryVariables = Types.Exact<{
  inactivitySearch: Types.InactivitySearch;
  pagination?: Types.InputMaybe<Types.Pagination>;
}>;


export type GetInactivitiesQuery = {
  __typename?: 'Query',
  inactivities?: {
    __typename?: 'InactivityPage',
    totalElements: number,
    content?: Array<{
      __typename?: 'Inactivity',
      id: number,
      voyageNumber?: string | null,
      type?: Types.InactivityType | null,
      start?: number | null,
      end?: number | null,
      created?: number | null,
      purchaseCharters?: Array<{
        __typename?: 'PurchaseCharter',
        id: number,
        type: Types.CharterType,
        charterNumber: string
      }> | null,
      calls?: Array<{
        __typename?: 'InactivityItem',
        id: number,
        location?: {
          __typename?: 'Location',
          id: number,
          description: string
        } | null
      } | null> | null,
      ship?: {
        __typename?: 'Ship',
        id: number,
        name: string
      } | null,
      from?: {
        __typename?: 'Location',
        id: number,
        description: string
      } | null,
      to?: {
        __typename?: 'Location',
        id: number,
        description: string
      } | null
    }> | null
  } | null
};

export type GetInactivityQueryVariables = Types.Exact<{
  id: Types.Scalars['Long']['input'];
}>;


export type GetInactivityQuery = {
  __typename?: 'Query',
  inactivity?: {
    __typename?: 'Inactivity',
    id: number,
    type?: Types.InactivityType | null,
    start?: number | null,
    end?: number | null,
    purchaseCharters?: Array<{
      __typename?: 'PurchaseCharter',
      id: number,
      charterNumber: string,
      validFrom?: number | null,
      validUntil?: number | null,
      type: Types.CharterType,
      subtype: Types.CharterSubtype,
      creditor: {
        __typename?: 'Relation',
        id: number,
        name: string
      },
      debtor: {
        __typename?: 'Relation',
        id: number,
        name: string
      }
    }> | null,
    calls?: Array<{
      __typename?: 'InactivityItem',
      id: number,
      location?: {
        __typename?: 'Location',
        id: number,
        description: string
      } | null
    } | null> | null,
    ship?: {
      __typename?: 'Ship',
      id: number,
      name: string
    } | null
  } | null
};

export type GetInactivityCharterQueryVariables = Types.Exact<{
  id: Types.Scalars['Long']['input'];
}>;


export type GetInactivityCharterQuery = {
  __typename?: 'Query',
  charter: {
    __typename: 'PurchaseCharter',
    type: Types.CharterType,
    subtype: Types.CharterSubtype,
    voyages?: Array<{
      __typename?: 'Voyage',
      id: number,
      start?: number | null,
      end?: number | null
    }> | null
  } | {
    __typename: 'SalesCharter',
    type: Types.CharterType,
    subtype: Types.CharterSubtype
  }
};


export const GetInactivitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInactivities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inactivitySearch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InactivitySearch"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inactivities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"inactivitySearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inactivitySearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseCharters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"calls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"created"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalElements"}}]}}]}}]} as unknown as DocumentNode<GetInactivitiesQuery, GetInactivitiesQueryVariables>;
export const GetInactivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInactivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inactivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseCharters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validUntil"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"Field","name":{"kind":"Name","value":"creditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"calls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}}]} as unknown as DocumentNode<GetInactivityQuery, GetInactivityQueryVariables>;
export const GetInactivityCharterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInactivityCharter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PurchaseCharter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voyages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"NullValue"}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"NullValue"}},{"kind":"Argument","name":{"kind":"Name","value":"excludeEmpty"},"value":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetInactivityCharterQuery, GetInactivityCharterQueryVariables>;